module.exports = __webpack_public_path__ + "img/TECHNOLOGY-BALENO-2.6e5c5cda.jpg";